module.exports = __webpack_public_path__ + "static/media/faq_img.94ef97f2.svg";